<template>
    <div class="form-input-list" :class="{'horizontal':formHorizontal,'focus':isFocus}">
        <label v-if="label !== ''" for="forLabel">{{label}} <span v-if="required" class="required">*</span></label>
        <div class="input">
            <input name="browser"
                   :placeholder="currentPlaceholder"
                   @click="focus()"
                   @keydown.8="toggle = search === '' ? false : toggle"
                   @keydown.up="move(-1)"
                   @keydown.down="move(+1)"
                   @keydown.enter="change(filterItems[select])"
                   @focus="isFocus=true"
                   @blur="isFocus=false"
                   v-model="search"
                   id="forLabel"
            >
            <div class="cross" @click="reset()" v-if="select !== 0 && !noCross">
                <i class="fal fa-times"></i>
            </div>
            <div class="after">
                <i class="fa fa-angle-down"></i>
            </div>
        </div>
        <ul class="list" :class="{'show':toggle}">
            <li v-for="(item,key) in filterItems" :key="key" :class="selectItem === item ? 'select' : ''" @click="change(item,key); ">{{ item.text }}</li>
        </ul>
    </div>
</template>

<script>
import events from "@/events/events";

export default {
    name: "input-select",
    model:{
        prop:'value',
        event:'change',
    },
    props:{
        label:{type:String,default:""},
        items:Array,
        value:[String,Number],
        placeholder:String,
        placeholderValue:{type:[Boolean,String],default:false},
        required:Boolean,
        noCross:Boolean,
        formHorizontal:Boolean,
    },
    data(){
        return{
            toggle:false,
            isFocus:false,
            search:"",
            searchFilter:"",
            select:0,
            selectItem:this.items[0],
        }
    },
    methods:{
        change(item){
            console.log("change",item)
            if(!item) return;
            
            this.$emit('change',item.value);
            this.search = "";
            this.searchFilter = "";
        },
        focus(){
            if(this.toggle){
                return this.blur();
            }
            this.toggle = true;
            this.searchFilter = "";
            setTimeout(() => {
                events.$on("body:click:mouse:up",this.blur)
            },10)
        },
        blur(){
            this.toggle = false;
            events.$off("body:click:mouse:up",this.blur)
        },
        move(sens){
            if(!this.toggle) {
                this.toggle = true;
                return;
            }
            this.select += sens;
            if(this.select >= this.filterItems.length) this.select = 0;
            if(this.select < 0) this.select = this.filterItems.length - 1;
            
            this.selectItem = this.filterItems[this.select];
        },
        reset(){
            this.select = 0;
            this.selectItem = this.filterItems[this.select];
            this.$emit('change',this.selectItem.value);
        }
    },
    computed:{
        current() {
            return this.items.find(i => i.value === this.value);
        },
        filterItems(){
            if(typeof this.value === "number"){
                return this.items.filter(i => i.value === this.searchFilter || i.text.match(this.searchFilter) || this.searchFilter === "")
            }
            return this.items.filter(i => i.value.match(this.searchFilter) || i.text.match(this.searchFilter) || this.searchFilter === "")
        },
        currentPlaceholder(){
            if(this.placeholderValue){
                switch(typeof this.placeholderValue) {
                    case "string" : return this.placeholderValue + ': ' + this.$t(this.current.text);
                    case "boolean" : return this.placeholder+": "+this.$t(this.current.text);
                }
            }
            
            if(this.toggle){
                return this.$t("...");
            }
            
            return this.$t(this.current.text)
        },
        forLabel(){
            return new Date().getTime();
        }
    },
    watch:{
        value(){
            this.select = this.filterItems.findIndex(i => i.value === this.value);
            this.selectItem = this.filterItems[this.select];
            console.log(this.select);
        },
        search(val,old){
            if(!this.toggle) this.toggle = true;
            
            this.select = 0;
            this.selectItem = this.filterItems[this.select];
            this.searchFilter = this.search;
        }
    },
    mounted() {
        this.select = this.filterItems.findIndex(i => i.value === this.value);
        this.selectItem = this.filterItems[this.select]
    }
}
</script>